import React from 'react';
import { Link } from 'components/core/Link';
import { Twitter, Facebook, Instagram, Pinterest } from 'components/svg';

export function SocialIcons() {
	return (
		<div className="social-icons">
			<Link
				href="https://twitter.com/SpareFoot"
				target="_blank"
				rel="noreferrer noopener nofollow"
				className="social-link"
				hideBorder
			>
				<Twitter />
			</Link>
			<Link
				href="https://www.facebook.com/SpareFoot"
				target="_blank"
				rel="noreferrer noopener nofollow"
				className="social-link"
				hideBorder
			>
				<Facebook />
			</Link>
			<Link
				href="https://www.instagram.com/sparefoot/"
				target="_blank"
				rel="noreferrer noopener nofollow"
				className="social-link"
				hideBorder
			>
				<Instagram />
			</Link>
			<Link
				href="https://www.pinterest.com/sparefoot/"
				target="_blank"
				rel="noreferrer noopener nofollow"
				className="social-link"
				hideBorder
			>
				<Pinterest />
			</Link>
		</div>
	);
}

export default SocialIcons;
